import { ChangeEvent, DataSourceAction, DataSourceExecutionEvent, DataSourceMode, LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutLateRouteControl } from "./autogen/AutogenLayoutLateRouteControl";
import { LogManager, ModelRow } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";

const log = LogManager.getLogger("lme.dispatch.asset.LateRouteControl");
export class LateRouteControl extends AutogenLayoutLateRouteControl {

    sourceLateRouteControlAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() == DataSourceAction.SEARCH) {
            if (this.mainDataSource.activeRow == null) {
                this.mainDataSource.createBlankRow().then(async (row) => {
                    this.setDefaultValues(row);
                    try {
                        const response = await row.post();
                        this.mainDataSource.setRowsAndMode(DataSourceMode.UPDATE, [response as ModelRow]);
                    } catch (error) {
                        log.error("Error posting default late route control row", error);
                        CommonDialogs.showServerError(error);
                    }
                });
            }
            else if (!this.activeRow.isNull("late_route_status_color")) {
                this.updateLateRouteStatusColor(this.activeRow.get("late_route_status_color", ""));
            }
        }
    }

    textboxLateRouteStatusOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selected = event.selection;
        this.updateLateRouteStatusColor(selected?.get("late_route_status_color", null) ?? null);
    }

    updateLateRouteStatusColor(color: string) {
        this.textboxLateRouteStatus._inputDiv.style.backgroundColor = color ?? "transparent";
        this.textboxLateRouteStatus.color = color != null ? "default.reverse" : "default";
    }

    switchClearViaPointOnChange(event: ChangeEvent) {
        const checked = this.switchClearViaPoint.checked;
        this.textboxViaPointClearRadius.enabled =
        this.textboxViaPointClearRadius.required = checked;
    }

    setDefaultValues(row: ModelRow) {
        row.set("id", 1);
        row.set("log_detail_level", 7);
        row.set("subsequent_eta", "N");
        row.set("position_add", "N");
        row.set("stop_status_update", "N");
        row.set("stop_date_update", "N");
        row.set("stop_add", "N");
        row.set("driver_callin_add", "N");
        row.set("consider_drv_hours", "N");
    }
}
